import { createContext } from "react";

export const SidebarContext: any = createContext<any>(null);
